import React, { ReactNode } from 'react';
import classNames from 'classnames';
import { createUseStyles } from 'react-jss';

import './BaseModalFooter.scss';

interface UseStylesProps {
  justify: string;
}

const useStyles = createUseStyles({
  modalFooter: {
    justifyContent: (props: UseStylesProps) => props.justify,
  },
});

type Props = {
  justify?: string;
  className?: string;
  children: ReactNode;
};

export default function BaseModalFooter(props: Props) {
  const { children, className = '', justify = 'flex-end' } = props;
  const classes = useStyles({ justify });

  return (
    <div
      className={classNames(
        'modal-custom-footer',
        className,
        classes.modalFooter,
      )}
    >
      {children}
    </div>
  );
}
